import React from 'react'
import clsx from 'clsx'

export const Input = React.forwardRef(function Input({ className, ...props }, ref) {
  return <input ref={ref} className={clsx('form-control rounded-3', className)} {...props} />
})